import { createElement } from "react";
import moment from "moment";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { JobTaskReferenceCellRenderer } from "tap/components/AGGrid/cell-renderers/JobTaskReferenceCellRenderer.jsx";
import { StatusMessageCellRenderer } from "tap/components/AGGrid/cell-renderers/StatusMessageCellRenderer.jsx";
import { formatJobTaskReferenceValue } from "tap/utils/formatJobTaskReferenceValue.js";
import { scalarizeJobTaskFieldValue } from "tap/utils/normalizeLicensingJobViewTask.js";

const referenceValueGetter =
  (field) =>
  ({ data }) =>
    formatJobTaskReferenceValue(data?.[field]);

const referenceValueFormatter = (params) =>
  formatJobTaskReferenceValue(
    params.value ?? params.data?.[params.colDef?.field],
  );

const referenceCellRenderer = (params) =>
  createElement(JobTaskReferenceCellRenderer, params);

export const id = {
  field: "jobId",
  headerName: "Job",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "jobTasks",
  },
  valueGetter: referenceValueGetter("jobId"),
  valueFormatter: referenceValueFormatter,
  cellRenderer: referenceCellRenderer,
  minWidth: 100,
};

export const taskStatus = {
  field: "taskStatus",
  headerName: "Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "taskStatus",
    page: "jobTasks",
  },
  valueGetter: referenceValueGetter("taskStatus"),
  valueFormatter: referenceValueFormatter,
  cellRenderer: referenceCellRenderer,
  minWidth: 200,
};

export const statusMessage = {
  field: "statusMessage",
  headerName: "Message",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "statusMessage",
    page: "jobTasks",
  },
  valueGetter: ({ data }) => scalarizeJobTaskFieldValue(data?.statusMessage),
  cellRenderer: StatusMessageCellRenderer,
  minWidth: 400,
};

export const taskDetails = {
  field: "taskDetails",
  headerName: "Details",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "taskDetails",
    page: "jobTasks",
  },
  valueGetter: referenceValueGetter("taskDetails"),
  valueFormatter: referenceValueFormatter,
  cellRenderer: referenceCellRenderer,
  minWidth: 200,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("M/DD/YYYY, h:mm:ss A") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "jobTasks",
  },
  minWidth: 200,
};

export const modifiedAt = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("M/DD/YYYY, h:mm:ss A") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "jobTasks",
  },
  minWidth: 200,
};

export const completedAt = {
  field: "completedAt",
  headerName: "Completed",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("M/DD/YYYY, h:mm:ss A") : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "completedAt",
    page: "jobTasks",
  },
  minWidth: 200,
};
